import React from 'react'
import { Link } from 'react-router-dom'
import SocialMedia from './SocialMedia'

const StoreNewWA = () => {
  return (
    <div className='store-full'>
        
        {/* <div className='store-box'>
            <div className='store-box-wrap'>
                <span class="scrolldiv" id='newdelhi'></span>
                <div className='store-overlaytext'>
                    <div className='store-bigtext'>The Experience Center <small> New Delhi</small></div>
                    <div className="social-btns">
                            <Link to={`https://wa.me/+919582475486`} target="_blank" rel="noopener noreferrer"><img src='images/social-icon/whatsapp.png' alt='connect us on Whatsapp' /></Link>
                            <Link to="https://ig.me/m/chaashni.couture/" target="_blank" rel="noopener noreferrer"><img src='images/social-icon/instagram.png' alt='connect us on Instagram' /></Link>
                        </div>
                </div>
                <img src='/images/delhi-showroom.jpg' alt='The Experience Center New Delhi' />            
            </div>
        </div> */}
        <div className='store-box store-box-single'>
            <div className='store-box-wrap'>
                 <span class="scrolldiv" id='dubai'></span>
                <div className='store-overlaytext'>
                    <div className='store-bigtext'>THE GULF FLAGSHIP <small>{/* Naraina, */} Dubai</small></div>
                    <div className="social-btns">
                            <Link to={`https://wa.me/+971503848387`} target="_blank" rel="noopener noreferrer"><img src='images/social-icon/whatsapp.png' alt='connect us on Whatsapp' /></Link>
                            <Link to="https://ig.me/m/chaashni.dubai" target="_blank" rel="noopener noreferrer"><img src='images/social-icon/instagram.png' alt='connect us on Instagram' /></Link>
                        </div>                   
                </div>
                <img src='/images/dubai-showroom-big.jpg' alt='The Experience Center Dubai' />            
            </div>
        </div>        
    </div>
  )
}

export default StoreNewWA
